// extracted by css-extract-rspack-plugin
export default {"toast":"Te1zt","icon":"WwIRB","body":"gLGT1","message":"vxWvZ","button":"kKbQl","primary":"Z0mLS","secondary":"WXCMY","dismiss":"B8UEE"};